import { FC } from 'react'

interface GridLayoutHelperProps {
  listLength: number | undefined
}

const GridLayoutHelper: FC<GridLayoutHelperProps> = ({ listLength }) => {
  return (
    (listLength || 0) < 4 &&
    Array.from({ length: 3 }, (_, index) => (
      <div key={`placeholder-${index}`}></div>
    ))
  )
}

export default GridLayoutHelper
